<template>
  <ExamAnalysis @goRepeat="goRepeat" reportType="package">
    <template v-slot:bread>
      <div class="bread">
        <ExamIndexBread></ExamIndexBread>
        <span class="slash">/</span>
        <router-link :to="{ name: 'ExamPackage' }">套卷练习</router-link>
        <span class="slash">/</span>
        <router-link :to="{ name: 'ExamPackagePaper', query: { id: package_id } }">
          {{ package_name }}
        </router-link>
        <span class="slash">/</span>
        <span>{{ paper_name }}</span>
        <span class="slash">/</span>
        <span class="current">题目解析</span>
      </div>
    </template>
  </ExamAnalysis>
</template>
<script>
import ExamAnalysis from './components/ExamAnalysis';
import ExamIndexBread from './components/ExamIndexBread.vue';

export default {
  name: 'ExamPackageAnalysis',
  components: {
    ExamAnalysis,
    ExamIndexBread,
  },
  data() {
    return {
      package_id: this.$route.query.package_id,
      package_name: this.$route.query.package_name,
      paper_id: this.$route.query.paper_id,
      paper_name: this.$route.query.paper_name,
    };
  },
  methods: {
    async goRepeat() {
      let data = await this.$http.post('/api/app/practice/report', {
        type: 5,
        report_id: this.$route.query.id,
      });
      if (data.length === 0) {
        this.$info('当前没有题目可以练习');
        return;
      }
      this.$router.push({
        name: 'ExamPackageDo',
        query: {
          id: data,
          package_id: this.package_id,
          package_name: this.package_name,
          paper_id: this.paper_id,
        },
      });
    },
  },
};
</script>
